import { Button, Fade, Menu, MenuItem } from "@mui/material";
import { useCallback, useMemo, useState } from "react";
import { useAppSelector } from "../../app/hooks";
import {
  selectBtcTv,
  selectGrp,
  selectRoleObj,
} from "../../features/auth/authSlice";
import { use } from "react";
const menuConfig = [{
    key: "BtcInit",
    label: "Init",
    link: "/BtcInit",
    roles: ["sysAdmin"],
  },
  {
    key: "BtcAdmin",
    label: "Admin",
    link: "/BtcAdmin",
    roles: ["admin"],
  },
  {
    key: "BtcQuy",
    label: "Quỹ",
    link: "/BtcQuy?id=default",
    roles: ["admin"],
  },
  {
    key: "BtcTv",
    label: "Thành viên",
    link: "/BtcTv",
    roles: ["admin"],
  },
  {
    key: "BtcHistory",
    label: "Lịch sử",
    link: "/BtcHistory",
    roles: ["admin"],
  },
  {
    key: "BtcReport",
    label: "Report",
    link: "/BtcReport",
    roles: ["admin"],
  },
  {
    key: "BtcUser",
    label: "BtcUser",
    link: "/BtcUser",
    roles: ["admin", "user"], // luôn hiển thị
  },
];

export default function BtcMenu({ navi }) {
  const btcTv = useAppSelector(selectBtcTv);
  const grp = useAppSelector(selectGrp);
  const roleObj = useAppSelector(selectRoleObj);

  const [anchorEl, setAnchorEl] = useState(null);
  
  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = useCallback(() => {
    setAnchorEl(null);
  },[setAnchorEl]);

  const userRoles = useMemo(() => {
    const roles = btcTv?.role ? [btcTv.role] : [];
    if (roleObj && roleObj.sys === "admin") { 
      roles.push("sysAdmin"); 
    }
    return roles;
  }, [btcTv, roleObj]);

  const canAccessAll = (itemRoles, userRoles) => {
    if (!itemRoles || itemRoles.length === 0) return true;
    return itemRoles.some(r => userRoles.includes(r));
  };

  const menuItems = useMemo(() => {
    return menuConfig
      .filter((item) => canAccessAll(item.roles, userRoles))
      .map((item) => (
        <MenuItem
          key={item.key}
          onClick={() => {
            navi(item.link);
            handleClose();
          }}
        >
          {item.label}
        </MenuItem>
      ));
  }, [userRoles, navi, handleClose]);

  return (
    <div>
      <Button
        id="fade-button"
        aria-controls={open ? "fade-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
        onClick={handleClick}
      >
        {`BTC-${grp.toUpperCase()}`}
      </Button>

      <Menu
        id="fade-menu"
        MenuListProps={{ "aria-labelledby": "fade-button" }}
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        TransitionComponent={Fade}
      >
        {menuItems}
      </Menu>
    </div>
  );
}
